import { Outlet } from 'react-router-dom';
import Footer from '@components/ui/Footer/Footer';
import Header from '@components/ui/Header/Header';
import { Toaster } from 'react-hot-toast';

type OfflineLayoutProps = {
    children?: any,
};

function OfflineLayout(props: OfflineLayoutProps) {

    return (
        <>
            <Header/>
            
            <Toaster
                position="bottom-center"
                toastOptions={{
                    style: {
                        borderRadius: '10px',
                        background: '#333',
                        color: '#fff',
                    },
                }}
            />
            
            <main>
                {props.children ? props.children : <Outlet/>}
            </main>
        </>
    );
}

export default OfflineLayout;
